import Vue from 'vue';
import Router from 'vue-router';

import SignIn from '@/views/SignIn.vue';
import Dashboard from '@/views/Dashboard.vue';
import Profile from '@/views/Profile.vue';
import History from '@/views/History.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/inloggen',
      name: 'signIn',
      component: SignIn,
    },
    {
      path: '/registreren',
      name: 'signUp',
      component: () => import('@/views/SignUp.vue'),
    },
    {
      path: '/inloggen/als',
      name: 'signInAs',
      component: () => import('@/views/SignInAs.vue'),
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: '/activate',
      name: 'activateAccount',
      props: true,
      component: () => import('@/views/Activation.vue'),
    },
    {
      path: '/wachtwoord-herstellen',
      name: 'resetPassword',
      props: true,
      component: () => import('@/views/ResetPassword.vue'),
    },
    {
      path: '/wachtwoord-instellen',
      name: 'setPassword',
      props: true,
      component: () => import('@/views/SetPassword.vue'),
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/geschiedenis',
      name: 'history',
      component: History,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/profiel',
      name: 'profile',
      component: Profile,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*',
      redirect: '/dashboard',
    },
  ],
});
